// extracted by mini-css-extract-plugin
export default {"icon":"CloneMenuButton__icon--2hp0E"};